<div class="formulario">
    <form [formGroup]="formulario" #psForm="ngForm">
        <div class="container jumbotron">

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <h1 mat-dialog-title class="titulo">Alterar Cadastro Máquina</h1>
                </div>
            </div>
            <div align="right" *ngIf="dataExpiracao">
                <div class="row justify-content-md-center">
                    <div class="col-lg-10">
                        Data de expiração: {{dataExpiracao}}
                    </div>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-form-field hintLabel="Max. 30 characteres" appearance="fill" class="full-width">
                        <input matInput placeholder="Nome da Máquina" maxlength="30" formControlName="nomeMaquina">
                        <mat-hint align="end">{{nomeMaquina.value?.length || 0}}/30</mat-hint>
                        <mat-error *ngIf="nomeMaquina.hasError('required')">
                            Nome da máquina é obrigatório.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    Tipo:
                    <mat-radio-group formControlName="qtdDiasExpiracao" class="person-radio-group">
                        <mat-radio-button color="primary" class="person-radio-button"
                            *ngFor="let envio of lstEnvios" [checked]="envio.checked" [value]="envio.value"
                            [id]="envio.id">
                            {{envio.name}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row justify-content-md-end">
                <div class="col-lg-10">
                    <div mat-dialog-actions class="botoes">
                        <br />
                        <button mat-raised-button class="md-icon-button btnOK" (click)="gravar()"
                            [disabled]="!psForm.valid">
                            Continuar
                        </button>
                        &nbsp;
                        <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
                            <img class="img-fluid" src="assets/icons/white_close_icon.png" width="16px" /> Fechar
                        </button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-progress-bar *ngIf="ishabilitado" mode="indeterminate"></mat-progress-bar>
                </div>
            </div>
        </div>
    </form>
</div>